import Vue from 'vue'
// axios
import axios from 'axios'

const baseURL = process.env.MODE_APP === 'prod' ? process.env.API_BASE_URL_PROD : process.env.API_BASE_URL_DEV
const axiosIns = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
})

axiosIns.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || ''
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

axiosIns.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config
    const refreshToken = localStorage.getItem('refreshToken')
    if (error.response?.status === 403 && refreshToken && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const { data } = await axiosIns.post('/auth/refreshToken', {
          refreshToken,
        })

        localStorage.setItem('accessToken', data.accessToken)
        localStorage.setItem('refreshToken', data.refreshToken)
        originalRequest.headers.common.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
        return axiosIns(error.config)
      } catch (e) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  },
)
Vue.prototype.$http = axiosIns
Vue.prototype.$api = axiosIns

export default axiosIns
